export default __webpack_public_path__ + "static/deepdark-aaea0beefe02c0a419aee31b968190b0.png";